// src/contexts/ExamDetailsContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { getExamDetails } from "../api/examDetails";

const ExamDetailsContext = createContext();

export const useExamDetails = () => {
  const context = useContext(ExamDetailsContext);
  if (!context) {
    throw new Error(
      "useExamDetails must be used within an ExamDetailsProvider"
    );
  }
  return context;
};

export const ExamDetailsProvider = ({ children }) => {
  const [firstExamDetails, setFirstExamDetails] = useState(null);
  const [allExamDetails, setAllExamDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchExamDetails = async () => {
    try {
      setLoading(true);
      const response = await getExamDetails();

      if (response.data && response.data.length > 0) {
        setAllExamDetails(response.data);
        setFirstExamDetails(response.data[0]);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch exam details");
      console.error("Error fetching exam details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExamDetails();
  }, []);

  const value = {
    firstExamDetails,
    allExamDetails,
    loading,
    error,
    refetch: fetchExamDetails,
  };

  return (
    <ExamDetailsContext.Provider value={value}>
      {children}
    </ExamDetailsContext.Provider>
  );
};
